 

import { useState } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Drawer,
  AppBar,
  Toolbar,
  List,
  Typography,
  Divider,
  IconButton,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Avatar,
  Menu,
  MenuItem,
} from "@mui/material";

import {
  Menu as MenuIcon,
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  Work as WorkIcon,
  Favorite as FavoriteIcon,
  Home as HomeIcon,
  // LocalOffer as OfferIcon,
  ContactMail as ContactIcon,
  Report as ReportIcon,
  AccountCircle,
  Logout,
  Search as SearchIcon,
  Receipt as ReceiptIcon,
} from "@mui/icons-material";

import { useAuth } from "../contexts/AuthContext";

// ✅ Pages
import DashboardHome from "./DashboardHome";
 
// NEW PAGES (create these)
import CreateStock from "./CreateStock";
import AvailableStock from "./AvailableStock";
  import SellBike from "./SellBike";
// import SoldBikeAdmin from "./SoldBikeAdmin";
// import SoldBikeShowroom from "./SoldBikeShowroom";
 // import ExchangeShowroom from "./ExchangeShowroom";
import FilterBikes from "./FilterBikes";
import FindBike from "./FindBike";
import CustomerDetails from "./CustomerDetails";
 import SalesReport from "./SalesReport";
// import ShowroomPerformance from "./ShowroomPerformance";
 import SoldBikeAdminView from "./SoldBikeAdminView";
import EntryReport from "./EntryReport";
import StockTransfer from "./StockTransfer";
import ExchangeBikeAdminView from "./ExchangeBikeAdminView";

import InvoiceList from "./InvoiceList";
import InvoiceView from "./InvoiceView";
import ShowroomStock from "./ShowroomStock";
import User from "./User";
import AccessoriesPage from "./Accessories";
import AccessoriesExpancePage from "./AccessoriesExpancePage";
import ProfitLossDashboard from "./ProfitLossDashboard";
import TransferCostAnalytics from "./TransferCostAnalytics";
import ReturnBike from "./ReturnBike";
import SoldBikeAdminViewUpdate from "./SoldBikeAdminViewUpdate";
import TransferSummaryPage from "./Transfersummarypage";

const drawerWidth = 240;

const Dashboard = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ UPDATED MENU
  const menuItems = [
    { text: "Dashboard", icon: <DashboardIcon />, path: "/dashboard" },
    { text: "Users", icon: <PeopleIcon />, path: "/dashboard/users" },

    { text: "Create Stock & Sell", icon: <HomeIcon />, path: "/dashboard/create-stock" },
    { text: "Transfer Summery", icon: <HomeIcon />, path: "/dashboard/transfer-summery" },
        // { text: "Find Bike", icon: <SearchIcon />, path: "/dashboard/find-bike" },
    { text: "Showroom Stock", icon: <HomeIcon />, path: "/dashboard/showroom-stock" },


    // { text: "Stock Transfer", icon: <WorkIcon />, path: "/dashboard/stock-transfer" },

    // { text: "Sell Bike", icon: <OfferIcon />, path: "/dashboard/sell-bike" },
    { text: "Sell  Summery ", icon: <WorkIcon />, path: "/dashboard/sold-bike-view" },
    // { text: "Sell  Summery update", icon: <WorkIcon />, path: "/dashboard/sold-bike-update-view" },
    // { text: "Sold Bikes (Showroom)", icon: <WorkIcon />, path: "/dashboard/sold-bike-showroom" },

    { text: "Exchange", icon: <FavoriteIcon />, path: "/dashboard/exchange-bike" },
    { text: "Return Bike", icon: <FavoriteIcon />, path: "/dashboard/return-bike" },


    // { text: "Profit/Loss", icon: <SearchIcon />, path: "/dashboard/profit-loss" }, //use as available stock
    // { text: "Exchange (Showroom)", icon: <FavoriteIcon />, path: "/dashboard/exchange-bike-showroom" },
    // {text:"pending Amount", icon:<FavoriteIcon />, path:"/dashboard/pending-amount"},

    // { text: "Filter Bikes", icon: <SearchIcon />, path: "/dashboard/filter-bikes" }, //use as available stock
     { text: "Customer Details", icon: <ContactIcon />, path: "/dashboard/customer-details" },

    { text: "Entry Report", icon: <ReportIcon />, path: "/dashboard/entry-report" },
    { text: "Sales Report", icon: <ReportIcon />, path: "/dashboard/sales-report" },
{ text: "Accessories Entry", icon: <HomeIcon />, path: "/dashboard/accessories" },  
 { text: "Accessories Expansion", icon: <HomeIcon />, path: "/dashboard/accessories-expansion" },  // { text: "Showroom Performance", icon: <ReportIcon />, path: "/dashboard/showroom-performance" },
{text: "Transfer Cost", icon: <WorkIcon />, path: "/dashboard/transfer-cost" }, 
    { text: "Invoice", icon: <ReceiptIcon />, path: "/dashboard/invoice" },
  ];

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    await logout();
    navigate("/login");
    handleMenuClose();
  };

  const drawer = (
    <div>
      <Toolbar>
        <Typography variant="h6">KAB Enterprise</Typography>
      </Toolbar>
      <Divider />

      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              selected={location.pathname === item.path}
              onClick={() => navigate(item.path)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <Box sx={{ display: "flex" }}>
      {/* 🔥 APPBAR */}
      <AppBar
        position="fixed"
     sx={{
  width: { md: `calc(100% - ${drawerWidth}px)` },
  ml: { md: `${drawerWidth}px` },
}}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={handleDrawerToggle}
sx={{ mr: 2, display: { md: "none" } }}          >
            <MenuIcon />
          </IconButton>

          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            KAB Enterprise Dashboard
          </Typography>

          <IconButton onClick={handleMenuClick} color="inherit">
            <Avatar>
              <AccountCircle />
            </Avatar>
          </IconButton>

          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
            <MenuItem onClick={handleMenuClose}>
              {user?.name || user?.email}
            </MenuItem>
            <MenuItem onClick={handleLogout}>
              <Logout fontSize="small" /> Logout
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      {/* 🔥 SIDEBAR */}
      <Box component="nav" sx={{ width: { sm: drawerWidth } }}>
     <Drawer
  variant="temporary"
  open={mobileOpen}
  onClose={handleDrawerToggle}
  sx={{ display: { md: "none" } }}
>
          {drawer}
        </Drawer>

        <Drawer
          variant="permanent"
          sx={{
display: { xs: "none", md: "block" },
            "& .MuiDrawer-paper": { width: drawerWidth },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>

      {/* 🔥 MAIN */}
      <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
        <Toolbar />

        <Routes>
          <Route path="/" element={<DashboardHome />} />
          <Route path="/users" element={<User />} />

          <Route path="/create-stock" element={<CreateStock/>} />
          <Route path="/transfer-summery" element={< TransferSummaryPage/>} />
          
          <Route path="/available-stock" element={<AvailableStock />} />
          <Route path="/showroom-stock" element={<ShowroomStock />} />

          {/* <Route path="/stock-transfer" element={<StockTransfer/>} /> */}

          <Route path="/sell-bike" element={<SellBike />} />
          <Route path="/sold-bike-view" element={<SoldBikeAdminView />} />
          <Route path="/sold-bike-update-view" element={<SoldBikeAdminViewUpdate />} />
           
          {/* <Route path="/sold-bike-showroom" element={<SoldBikeShowroom />} />  need when make showroom wise bikw */}

          <Route path="/exchange-bike" element={<ExchangeBikeAdminView />} />
          <Route path="/return-bike" element={<ReturnBike />} />
           {/* <Route path="/exchange-bike-showroom" element={<ExchangeShowroom />} />need when make showroom wise bikw */}

          {/* <Route path="/filter-bikes" element={<FilterBikes />} /> */}
          {/* <Route path="/find-bike" element={<FindBike />} /> */}
          <Route path="/customer-details" element={<CustomerDetails />} />
            <Route path="/profit-loss" element={<ProfitLossDashboard />} />  {/* create profit loss page and link here */}
          {/* <Route path="/pending-amount" element={<PendingAmount />} />  create pending amount page and link here */}

          <Route path="/entry-report" element={<EntryReport />} />
          <Route path="/sales-report" element={<SalesReport />} />
          {/* <Route path="/showroom-performance" element={<ShowroomPerformance />} /> */}
          <Route path="/accessories" element={<AccessoriesPage />} />  {/* create accessories page and link here */}
          <Route path="/accessories-Expansion" element={<AccessoriesExpancePage />} />  {/* create accessories page and link here */}
<Route path="/transfer-cost" element={<TransferCostAnalytics />} />  {/* create stock transfer page and link here */}
<Route path="/invoice" element={<InvoiceList />} />
<Route path="/invoice/:saleId" element={<InvoiceView/>} />
        </Routes>
      </Box>
    </Box>
  );
};

export default Dashboard;